<template>
  <dialog-base
    :visible.sync="visible"
    title="Hướng dẫn thiết lập & quản lý gói học phí"
    size="lg"
    cancel-text="Đóng"
    confirm-text="Đã hiểu"
    :use-panel="false"
    :append-to-body="true"
    top="5vh"
    @confirm="handleClose"
    @cancel="handleClose"
  >
    <div class="pkg-guide">
      <!-- PHẦN 1: MÔ HÌNH CHU KỲ THEO HỌC SINH -->
      <div class="pkg-guide-section">
        <p class="pkg-guide-title">
          <i class="el-icon-user pkg-guide-icon" /> 1) Mô hình chu kỳ học phí theo từng học sinh
        </p>
        <p class="pkg-guide-desc">
          Gói học phí <strong>không có ngày bắt đầu/kết thúc tổng thể</strong>. Thay vào đó, mỗi học sinh có chu kỳ riêng bắt đầu từ ngày học sinh được thêm vào gói:
        </p>
        <div class="pkg-guide-cards-3">
          <div class="pkg-guide-time-card">
            <span class="pkg-guide-time-num">1</span>
            <div>
              <strong>Cách tính & thu học phí</strong>
              <p>Khoảng thời gian được tính tiền trong 1 lần thu (ví dụ: thu 3 tháng/lần, 1 năm/lần).</p>
            </div>
          </div>
          <div class="pkg-guide-time-card">
            <span class="pkg-guide-time-num">2</span>
            <div>
              <strong>Chu kỳ của từng học sinh</strong>
              <p>Bắt đầu từ ngày học sinh tham gia vào gói. Mỗi học sinh có thể có ngày bắt đầu khác nhau.</p>
            </div>
          </div>
          <div class="pkg-guide-time-card">
            <span class="pkg-guide-time-num">3</span>
            <div>
              <strong>Khoảng trên phiếu thu</strong>
              <p>Khoảng áp dụng hiển thị cho phụ huynh lấy từ startValidityPeriod / endValidityPeriod của phiếu thu.</p>
            </div>
          </div>
        </div>

        <div class="pkg-guide-formula mt-2">
          <code>Ngày bắt đầu chu kỳ 1 = Ngày học sinh tham gia gói</code>
        </div>
        <div class="pkg-guide-formula">
          <code>Ngày bắt đầu chu kỳ N+1 = Ngày kết thúc chu kỳ N + 1 ngày</code>
        </div>
        <p class="pkg-guide-example mt-1">
          Ví dụ: Học sinh A tham gia ngày <strong>01/08/2026</strong>, gói thu 3 tháng/lần:<br/>
          → Chu kỳ 1: <strong>01/08/2026 – 31/10/2026</strong><br/>
          → Chu kỳ 2: <strong>01/11/2026 – 31/01/2027</strong><br/>
          Nếu học sinh B tham gia ngày <strong>15/08/2026</strong>, chu kỳ đầu của B là <strong>15/08/2026 – 14/11/2026</strong>.
        </p>
      </div>

      <!-- PHẦN 2: CẤU HÌNH GÓI -->
      <div class="pkg-guide-section">
        <p class="pkg-guide-title">
          <i class="el-icon-edit-outline pkg-guide-icon" /> 2) Chi tiết các trường cấu hình gói
        </p>
        <ul>
          <li>
            <strong>Đơn vị tính học phí:</strong> Chọn Hàng tháng, Hàng năm, Hàng ngày hoặc Thu một lần.
          </li>
          <li>
            <strong>Số đơn vị thu mỗi lần:</strong> Số tháng/năm/ngày được thu trong một lần. Ví dụ: Hàng tháng và số 3 → Thu 3 tháng mỗi lần.
          </li>
          <li>
            <strong>Cho phép tự động gia hạn:</strong> Bật chính sách gia hạn cho gói. Mỗi lần gia hạn sẽ tạo một chu kỳ mới theo đúng cách tính học phí.
            <em>Nhân viên vẫn cần vào danh sách để chọn học sinh được gia hạn.</em>
          </li>
          <li>
            <strong>Nhắc lần đầu trước hạn (ngày):</strong> Số ngày trước khi hết hạn sẽ bắt đầu nhắc. Ví dụ: 10 → Nhắc trước 10 ngày.
          </li>
          <li>
            <strong>Nhắc lại mỗi (ngày/lần):</strong> Sau lần nhắc đầu, hệ thống tiếp tục nhắc lại theo tần suất này cho đến khi hết hạn. Ví dụ: 3 → Nhắc mỗi 3 ngày.
            <div class="pkg-guide-highlight">
              <i class="el-icon-warning" /> Nếu không muốn nhắc lại, để trống trường này. Hệ thống chỉ nhắc đúng một lần vào ngày đã thiết lập. Hủy tự động gia hạn không xóa lịch nhắc của chu kỳ hiện tại; sau ngày hết hạn thì dừng.
            </div>
          </li>
        </ul>
      </div>

      <!-- PHẦN 3: VÍ DỤ LỊCH NHẮC HẠN -->
      <div class="pkg-guide-section">
        <p class="pkg-guide-title">
          <i class="el-icon-bell pkg-guide-icon" /> 3) Ví dụ lịch nhắc hạn
        </p>
        <p class="pkg-guide-desc">Chu kỳ hết hạn <strong>31/10/2026</strong>, nhắc lần đầu <strong>10 ngày</strong> trước, nhắc lại <strong>mỗi 3 ngày</strong>:</p>
        <div class="pkg-guide-reminder-list">
          <div class="pkg-guide-reminder-item">
            <span class="pkg-guide-reminder-date">21/10/2026</span>
            <span>Nhắc lần đầu (trước 10 ngày)</span>
          </div>
          <div class="pkg-guide-reminder-item">
            <span class="pkg-guide-reminder-date">24/10/2026</span>
            <span>Nhắc lại lần 2 (+ 3 ngày)</span>
          </div>
          <div class="pkg-guide-reminder-item">
            <span class="pkg-guide-reminder-date">27/10/2026</span>
            <span>Nhắc lại lần 3 (+ 3 ngày)</span>
          </div>
          <div class="pkg-guide-reminder-item">
            <span class="pkg-guide-reminder-date">30/10/2026</span>
            <span>Nhắc lại lần 4 (+ 3 ngày)</span>
          </div>
        </div>
      </div>

      <!-- PHẦN 4: CÁC VÍ DỤ CẤU HÌNH -->
      <div class="pkg-guide-section">
        <p class="pkg-guide-title">
          <i class="el-icon-document-copy pkg-guide-icon" /> 4) Các ví dụ cấu hình thực tế
        </p>

        <div class="pkg-guide-example-card">
          <p class="pkg-guide-example-title">
            <el-tag type="success" size="mini">Ví dụ phổ biến</el-tag> Thu 3 tháng, nhắc trước 10 ngày, nhắc lại 3 ngày
          </p>
          <div class="pkg-guide-example-body">
            <p><strong>Cấu hình:</strong> Đơn vị tính: <em>Hàng tháng</em> | Số đơn vị: <em>3</em> | Tự động gia hạn: <em>Bật</em> | Nhắc đầu: <em>10 ngày</em> | Nhắc lại: <em>3 ngày/lần</em></p>
            <p class="pkg-guide-example-result">
              <i class="el-icon-right" /> <strong>Diễn giải:</strong> Học phí thu 3 tháng/lần. Trước khi hết hạn 10 ngày bắt đầu nhắc, sau đó nhắc mỗi 3 ngày. Khi hết chu kỳ, hệ thống tự tạo chu kỳ mới 3 tháng tiếp theo.
            </p>
          </div>
        </div>

        <div class="pkg-guide-example-card">
          <p class="pkg-guide-example-title">
            <el-tag type="primary" size="mini">Ví dụ đơn giản</el-tag> Thu 1 tháng, chỉ nhắc 1 lần
          </p>
          <div class="pkg-guide-example-body">
            <p><strong>Cấu hình:</strong> Đơn vị tính: <em>Hàng tháng</em> | Số đơn vị: <em>1</em> | Tự động gia hạn: <em>Bật</em> | Nhắc đầu: <em>5 ngày</em> | Nhắc lại: <em>để trống</em></p>
            <p class="pkg-guide-example-result">
              <i class="el-icon-right" /> <strong>Diễn giải:</strong> Thu học phí mỗi tháng. Nhắc 1 lần duy nhất vào 5 ngày trước khi hết hạn.
            </p>
          </div>
        </div>

        <div class="pkg-guide-example-card">
          <p class="pkg-guide-example-title">
            <el-tag type="info" size="mini">Ví dụ thu một lần</el-tag> Phí nhập học, đồng phục
          </p>
          <div class="pkg-guide-example-body">
            <p><strong>Cấu hình:</strong> Đơn vị tính: <em>Thu một lần</em> | Tự động gia hạn: <em>Đã khóa (không áp dụng)</em></p>
            <p class="pkg-guide-example-result">
              <i class="el-icon-right" /> <strong>Diễn giải:</strong> Chỉ thu 1 lần duy nhất. Hệ thống không tạo chu kỳ tiếp theo.
            </p>
          </div>
        </div>
      </div>

      <!-- PHẦN 5: QUY TRÌNH VẬN HÀNH -->
      <div class="pkg-guide-section">
        <p class="pkg-guide-title">
          <i class="el-icon-guide pkg-guide-icon" /> 5) Quy trình vận hành 4 bước
        </p>
        <div class="pkg-guide-steps">
          <div class="pkg-guide-step-item">
            <span class="pkg-guide-step-num">1</span>
            <div class="pkg-guide-step-content">
              <strong>Khởi tạo gói học phí</strong>
              <p>Điền thông tin gói, chọn đơn vị thu và thiết lập cấu hình nhắc hạn / tự động gia hạn.</p>
            </div>
          </div>
          <div class="pkg-guide-step-item">
            <span class="pkg-guide-step-num">2</span>
            <div class="pkg-guide-step-content">
              <strong>Thêm học sinh vào gói</strong>
              <p>Nhấn biểu tượng <em>Quản lý thành viên</em> (hình người). Ngày tham gia = ngày bắt đầu chu kỳ 1.</p>
            </div>
          </div>
          <div class="pkg-guide-step-item">
            <span class="pkg-guide-step-num">3</span>
            <div class="pkg-guide-step-content">
              <strong>Đăng ký tự động gia hạn</strong>
              <p>Nhấn biểu tượng <em>Quản lý tự động gia hạn</em> (hình xoay vòng) để chọn học sinh áp dụng.</p>
            </div>
          </div>
          <div class="pkg-guide-step-item">
            <span class="pkg-guide-step-num">4</span>
            <div class="pkg-guide-step-content">
              <strong>Hệ thống tự động xử lý</strong>
              <p>Khi đến hạn, hệ thống tạo chu kỳ mới và khởi tạo phiếu thu tương ứng cho học sinh đã đăng ký.</p>
            </div>
          </div>
        </div>
      </div>

      <div class="pkg-guide-tip">
        <i class="el-icon-magic-stick" /> <strong>Mẹo:</strong> Trong quá trình thao tác trên biểu mẫu, bạn có thể rê chuột vào biểu tượng dấu hỏi chấm <i class="el-icon-question" /> cạnh từng ô nhập liệu để xem giải thích nhanh tại chỗ.
      </div>
    </div>
  </dialog-base>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";

export default {
  name: "PackageGuideDialog",
  components: { DialogBase },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    open() {
      this.visible = true;
    },
    handleClose() {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.pkg-guide {
  max-height: 72vh;
  overflow-y: auto;
  padding-right: 6px;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

.pkg-guide-section + .pkg-guide-section {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px dashed #e2e8f0;
}

.pkg-guide-title {
  margin: 0 0 8px;
  font-size: 14.5px;
  font-weight: 700;
  color: #0f172a;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  line-height: 1.4;
}

.pkg-guide-icon {
  color: #2563eb;
  font-size: 16px;
  flex-shrink: 0;
}

.pkg-guide-desc {
  margin: 0 0 8px;
  font-size: 13px;
  color: #475569;
  line-height: 1.5;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

ul {
  margin: 0 0 6px 18px;
  padding: 0;
  color: #334155;
  line-height: 1.6;
  font-size: 13px;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

li {
  margin-bottom: 5px;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

.pkg-guide-sublist {
  margin-top: 4px;
  margin-bottom: 4px;
  list-style-type: circle;
}

.pkg-guide-highlight {
  margin-top: 8px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  color: #92400e;
  font-size: 12.5px;
  line-height: 1.5;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

.pkg-guide-example {
  margin: 4px 0 0;
  color: #0f766e;
  font-size: 12.5px;
  line-height: 1.6;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

.pkg-guide-formula {
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 13px;
  color: #1e293b;
  margin: 6px 0;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  line-height: 1.5;

  code {
    font-weight: 700;
    color: #2563eb;
    font-family: inherit;
    word-break: break-word;
    overflow-wrap: break-word;
    white-space: normal;
  }
}

/* 3 Time Cards */
.pkg-guide-cards-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  margin-top: 8px;
}

@media (max-width: 768px) {
  .pkg-guide-cards-3 {
    grid-template-columns: 1fr;
  }
}

.pkg-guide-time-card {
  display: flex;
  gap: 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 12px;
  min-width: 0;

  div {
    flex: 1;
    min-width: 0;
    word-break: break-word;
    overflow-wrap: break-word;
  }

  strong {
    display: block;
    font-size: 12.5px;
    color: #1e293b;
    margin-bottom: 3px;
    word-break: break-word;
    overflow-wrap: break-word;
    white-space: normal;
    line-height: 1.4;
  }

  p {
    margin: 0;
    font-size: 11.5px;
    color: #64748b;
    line-height: 1.4;
    word-break: break-word;
    overflow-wrap: break-word;
    white-space: normal;
  }
}

.pkg-guide-time-num {
  width: 24px;
  height: 24px;
  background: #2563eb;
  color: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 12px;
  flex-shrink: 0;
}

/* Reminder list */
.pkg-guide-reminder-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 8px;
}

.pkg-guide-reminder-item {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 6px 12px;
  font-size: 12.5px;
  color: #334155;
  flex-wrap: wrap;
  word-break: break-word;
  overflow-wrap: break-word;

  span:last-child {
    flex: 1;
    min-width: 0;
    word-break: break-word;
    overflow-wrap: break-word;
    white-space: normal;
  }
}

.pkg-guide-reminder-date {
  font-weight: 700;
  color: #2563eb;
  min-width: 90px;
  flex-shrink: 0;
}

/* Example Cards */
.pkg-guide-example-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 14px;
  margin-bottom: 8px;
  word-break: break-word;
  overflow-wrap: break-word;
}

.pkg-guide-example-title {
  margin: 0 0 6px;
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
  line-height: 1.4;
}

.pkg-guide-example-body {
  font-size: 12.5px;
  color: #334155;
  line-height: 1.5;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;

  p {
    margin: 2px 0;
    word-break: break-word;
    overflow-wrap: break-word;
    white-space: normal;
  }
}

.pkg-guide-example-result {
  color: #166534;
  font-weight: 600;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

/* Steps 4 bước */
.pkg-guide-steps {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  margin-top: 8px;
}

@media (max-width: 768px) {
  .pkg-guide-steps {
    grid-template-columns: 1fr;
  }
}

.pkg-guide-step-item {
  display: flex;
  gap: 10px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 12px;
  min-width: 0;
}

.pkg-guide-step-num {
  width: 26px;
  height: 26px;
  background: #2563eb;
  color: #ffffff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 13px;
  flex-shrink: 0;
}

.pkg-guide-step-content {
  flex: 1;
  min-width: 0;
  word-break: break-word;
  overflow-wrap: break-word;

  strong {
    display: block;
    font-size: 13px;
    color: #1e293b;
    margin-bottom: 2px;
    word-break: break-word;
    overflow-wrap: break-word;
    white-space: normal;
    line-height: 1.4;
  }
  p {
    margin: 0;
    font-size: 12px;
    color: #64748b;
    line-height: 1.4;
    word-break: break-word;
    overflow-wrap: break-word;
    white-space: normal;
  }
}

.pkg-guide-tip {
  margin-top: 14px;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1px solid #bfdbfe;
  background: #eff6ff;
  color: #1d4ed8;
  font-size: 12.5px;
  line-height: 1.5;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}
</style>
